// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"39": "12cfedee6c1cf6d2","478": "0584c0926a162c98",}[chunkId] + ".js"
}